// =====================================================================
//  input.js — calculator-input value helpers (read / write).
//
//  Lets calculator controllers read numbers from any form control —
//  masked input, plain input, or <select> — without branching on type.
//  When an Inputmask is attached, the helpers go through the library's
//  unmaskedvalue() / setValue() API; otherwise they fall through to
//  Calc.format.parseNumber and a direct .value assignment.
//
//  This file is independent of input-mask.js: it works whether or not
//  any masks are attached. input-mask.js owns the masking setup.
//
//  Depends on: Calc.format (format.js).
//
//  Public API:
//    Calc.input.syncValue(idOrEl, val) — write a value, respects any mask
//    Calc.input.getValue(el)           — read clean numeric value (0 if
//                                        empty / unparseable)
// =====================================================================
window.Calc = window.Calc || {};

Calc.input = {
  // Write a value into an input. Skipped if the user is currently
  // focused on the input (avoids stomping their in-progress typing).
  //
  // For masked inputs, we short-circuit when the unmasked value already
  // matches the target. This is critical: Inputmask.setValue fires an
  // `input` event, and calculators call syncValue from inside their input
  // handlers (via refresh), so without this guard we'd loop forever.
  syncValue(idOrEl, val) {
    const el = typeof idOrEl === 'string' ? document.getElementById(idOrEl) : idOrEl;
    if (!el || document.activeElement === el) return;
    if (el.inputmask) {
      const current = el.inputmask.unmaskedvalue();
      const currentNum = typeof current === 'number' ? current : parseFloat(current);
      const targetNum  = typeof val     === 'number' ? val     : parseFloat(val);
      if (currentNum === targetNum) return;
      el.inputmask.setValue(val);
    } else {
      el.value = val;
    }
  },

  // Read a numeric value from any form control — masked input, plain
  // input, or select. Returns 0 for empty / unparseable values.
  getValue(el) {
    if (!el) return 0;
    if (el.inputmask) {
      const u = el.inputmask.unmaskedvalue();
      const n = typeof u === 'number' ? u : parseFloat(u);
      return isNaN(n) ? 0 : n;
    }
    return Calc.format.parseNumber(el.value);
  },
};
